import { Avatar, Card, Row, Skeleton } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import Meta from 'antd/lib/card/Meta';
import moment from 'moment';
import 'moment/locale/zh-hk';
import { useCallback } from 'react';

import { NotificationModel } from 'services/types/NotificationTypes';
import i18n from 'utils/i18n';

import './Notifications.css';

interface NotificationItemProps {
  notification?: NotificationModel
}

const NotificationItem: React.FC<NotificationItemProps> = ({
  notification
}) => {
  moment.locale(i18n.language);
  const isLoading = !notification;

  const getLocalizedMessage = useCallback((): string => {
    if (!notification?.message) return '';

    const defaultLanguage = 'en';
    const currentLanguage = i18n.language;

    return notification.message[currentLanguage] ||
      notification.message[defaultLanguage] ||
      '';
  }, [notification?.message]);

  const profileImage = notification?.image_small_url || notification?.user?.profile?.image_small_url;

  return (
    <Card bordered={false}>
      <Card.Grid hoverable={false} style={{ width: '75%', padding: 12, boxShadow: 'none' }}>
        <Skeleton loading={isLoading} avatar={{ shape: 'circle' }} paragraph={false} active>
          <Meta
            avatar={
              <Avatar
                src={profileImage}
                size={'large'}
                icon={<UserOutlined />}
              />
            }
            title={
              <div>
                <Row style={{ fontSize: 14 }}>{getLocalizedMessage()}</Row>
              </div>
            }
          />
        </Skeleton>
      </Card.Grid>
    </Card>);
};

export default NotificationItem;